import { css } from 'styled-components';
import {
  BADGE_ROUNDED_FONT_SIZE,
  BADGE_ROUNDED_HEIGHT,
} from 'HubStyleTokens/sizes';
import {
  FONT_FAMILIES,
  setBorderRadius,
  setFontSmoothing,
} from '../utils/Styles';

const badgeTextStyles = css`
  ${FONT_FAMILIES.bold};
  font-size: ${BADGE_ROUNDED_FONT_SIZE};
  ${setFontSmoothing('antialiased')};
  text-align: center;
  text-transform: uppercase;
  vertical-align: inherit;
  hyphens: manual;
`;

export const badgeStylesMixin = css`
  display: inline-block;
  ${badgeTextStyles};
  ${setBorderRadius()};
  line-height: ${BADGE_ROUNDED_HEIGHT};
  min-height: ${BADGE_ROUNDED_HEIGHT};
`;
